<template>
  <div>
    <!-- Container-fluid starts-->
    <div
      v-if="vendorManagementAvailable"
      class="container-fluid"
    >
      <router-view ></router-view>
    </div>
    <div v-else>
      <div
        v-if="sessionType === 'personal' || company.format === 'PERSONAL'"
        class="card"
      >
        <div class="card-body">
          <p>{{ $t('vendorManagement.frdiXsProfiliNVendorManagementAktivDeyilVendorMana') }} </p>

          <router-link
            class="btn btn-primary"
            :to="{name: 'changeAccount' }"
          >
            {{ $t('dashboardVue.profilSein') }}
          </router-link>
        </div>
      </div>
      <div
        v-else
        class="card"
      >
        <div class="card-body">
          <p>{{ $t('vendorManagement.hesabnzdaVendorManagementAktivDeyil') }} </p>

          <router-link
            class="btn btn-primary"
            :to="{name: 'addOnPage' }"
          >
            {{ $t('newInfoRequest.aktivldir') }}
          </router-link>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getVendorManagementStatus} from "@/repositories/GeneralDataRepository";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      vendorManagementAvailable: false
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
      sessionType: state => state.auth.sessionType,
      company: state => state.auth.company,
    }),
  },
  mounted() {
    getVendorManagementStatus(this.token).then((data) => {
      console.log(data)
      this.vendorManagementAvailable = data.code === 200;
    });
  },
  methods: {}
}
</script>
